import {Component, Input, OnInit} from '@angular/core';
import {OperationPrivilageModel} from '../../../shared/dto/operation-privilage-model';
import {WorkFlowStageModel} from '../../../shared/dto/work-flow-stage-model';

@Component({
  selector: 'app-assign-workflow-stage-search-table',
  templateUrl: './assign-workflow-stage-search-table.component.html',
  styleUrls: ['./assign-workflow-stage-search-table.component.scss']
})
export class AssignWorkflowStageSearchTableComponent implements OnInit {
  @Input() data:  OperationPrivilageModel[] = [];
  array: OperationPrivilageModel[] = [];
  public workflowStageCodes: WorkFlowStageModel [] = [];

  constructor() { }

  ngOnInit() {
  }


  onDelete(i){
    this.data.splice(i);
  }


}
